import { normalizeMyPermissions, type MyPermissions } from "@/lib/permissions";
import { BaseProvider } from "./base.provider";

class PermissionsProvider extends BaseProvider {
  // Any logged-in user can call this; a user with no grant gets every area at
  // "none", never a 404. Silent on 403 because a suspended account is denied
  // here too, and the 403 handler refreshes exactly this call.
  async getMine(): Promise<MyPermissions> {
    return normalizeMyPermissions(
      await this.requestSilentOn403<MyPermissions>("/v1/users/me/permissions"),
    );
  }
}

export const permissionsProvider = new PermissionsProvider();
